import { render } from "./productPackages.vue?vue&type=template&id=502983ca"
import script from "./productPackages.vue?vue&type=script&lang=js"
export * from "./productPackages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/vueComponents/admin/productPackages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "502983ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('502983ca', __exports__)) {
    api.reload('502983ca', __exports__)
  }
  
  module.hot.accept("./productPackages.vue?vue&type=template&id=502983ca", () => {
    api.rerender('502983ca', render)
  })

}


export default __exports__